<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-card>
        <b-table
          v-if="$ability.can(constants.action.permissionOrdersList, constants.resource.user)"
          ref="roles"
          class="position-relative"
          selectable
          :fields="tableFields"
          :items="ordersData"
          :select-mode="selectMode"
          hover
          @row-selected="onRowSelected"
        />
        <!-- <orders-modal
          :order-data="orderData"
          :modal-loads="modalLoader"
          :show="!modalLoader"
          :reload-method="getOrders"
        /> -->
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
  },
  data() {
    return {
      searchBy: 'All',
      loader: false,
      ordersData: [],
      qtyToInvoice: 0,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      searchByOptions: ['All', 'Active', 'Inactive'],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      editData: {},
      addApiToken: {
        id: 0,
        client_id: '',
        secret: '',
        name: '',
        description: '',
        parent_id: JSON.parse(localStorage.getItem('userData')).data.id,
      },
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      modalLoader: true,
      constants,
      isSuperAdmin: false,
      selectMode: 'single',
      orderData: {},
      orderId: 0,
    }
  },
  computed: {
    tableFields() {
      return [
        { key: 'cvrcpr', sortable: true, label: i18n.t('DEBTIA_CVR_CPR') },
        { key: 'debtor_type', sortable: true, label: i18n.t('DEBTIA_TYPE') },
        { key: 'debtor_name', sortable: true, label: i18n.t('DEBTIA_NAME') },
        { key: 'client_id', sortable: true, label: i18n.t('DEBTIA_CLIENT_REF') },
        { key: 'order_date', label: i18n.t('DEBTIA_ORDER_DATE') },
      ]
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0 && this.searchRun) {
          this.searchRun = false
          this.currentPage = 1
          this.getOrders()
        }
      },
    },
    currentPage: {
      handler() {
        this.getOrders()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getOrders()
      },
    },
  },
  created() {
    this.getOrders()
    this.actionColumn()
  },
  methods: {
    onRowSelected(item) {
      this.modalLoader = true
      this.orderData = item['0']
      this.$router.push(`/order/details/${item['0'].order.no}`)
      // this.modalLoader = false
    },
    searchRecords() {
      if (this.searchQuery.length > 0) {
        this.searchRun = true
        this.getOrders()
      }
    },
    async getOrders() {
      try {
        // if (this.user_type === 'super-admin' || this.user_type === 'system-user') {
        //   this.isSuperAdmin = true
        // } else {
        //   this.isSuperAdmin = false
        // }
        this.loader = true
        const orders = await axios.get(`${constants.baseUrl}/clients/get-orders`)
        this.loader = false
        if (orders.status) {
          this.ordersData = orders.data.data.orders
          this.loader = false
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    // apiToken(item) {
    //   this.modalLoader = true
    //   this.editData = item
    //   this.modalLoader = false
    // },
    async deleteApiToken(id) {
      this.loader = true
      const apiTokens = await axios.post(`${constants.baseUrl}/api-token/delete/${id}`)
      if (apiTokens.status) {
        this.getOrders()
      }
      this.loader = false
    },
    async orderStatus(id, status) {
      this.loader = true
      const st = status === 1 ? 0 : 1
      const apiTokens = await axios.post(`${constants.baseUrl}/api-token/revoke/${id}`,
        { status: st })
      if (apiTokens.status) {
        this.getOrders()
      }
      this.loader = false
    },
    confirmation(id, name, type, status) {
      // methodId
      let msg = ''
      if (type === 1) {
        msg = 'DEBTIA_DELETION_MSG'
      } else {
        msg = status === 1 ? 'DEBTIA_DEACTIVATE_MSG' : 'DEBTIA_ACTIVATE_MSG'
      }
      const question = ` '${name}' ?`
      this.$swal({
        title: i18n.t('DEBTIA_CAUTION'),
        text: i18n.t(msg) + question,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('DEBTIA_YES'),
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          if (type === 1) {
            this.deleteApiToken(id)
          } else {
            this.apiTokenStatus(id, status)
          }
        }
      })
    },
    actionColumn() {
      if (this.$ability.cannot(this.constants.action.permissionApiTokenEdit, this.constants.resource.apiToken) && this.$ability.cannot(this.constants.action.permissionApiTokenDelete, this.constants.resource.apiToken) && this.$ability.cannot(this.constants.action.permissionApiTokenRevoke, this.constants.resource.apiToken)) {
        this.tableFields.splice(4, 1)
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.query-input{
  padding: 0px
}

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
